import React from 'react'
import {
  FacebookIcon,
  FacebookShareButton,
  LineShareButton,
  LineIcon,
} from 'react-share'
import { useMediaQuery } from 'react-responsive'

const ShareBtn = ({ showShareBtn, shareUrl }) => {
  const shareTitle = '快來跟我一起用 EZChoice 填問卷拿獎勵！'
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        shareUrl +
          '?utm_source=copyLinkShare&utm_medium=inapp&openExternalBrowser=1'
      )
      .then(() => alert('連結已成功複製！'))
      .catch((err) => console.error('Failed to copy link: ', err))
  }
  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  return (
    <>
      {showShareBtn && (
        <div className="shareArea">
          <h4>分享給朋友一起填問卷拿獎勵！</h4>
          <div className="shareGroup">
            <FacebookShareButton
              url={
                shareUrl +
                '?utm_source=fbShare&utm_medium=inapp&openExternalBrowser=1'
              }
              className="Demo__some-network__share-button"
            >
              <FacebookIcon size={isMobile ? 40 : 32} round />
            </FacebookShareButton>
            <LineShareButton
              url={
                shareUrl +
                '?utm_source=lineShare&utm_medium=inapp&openExternalBrowser=1'
              }
              title={shareTitle}
              className="Demo__some-network__share-button"
            >
              <LineIcon size={isMobile ? 40 : 32} round />
            </LineShareButton>
            <button
              className="react-share__ShareButton Demo__some-network__share-button"
              onClick={copyToClipboard}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                padding: '0px',
                cursor: 'pointer',
              }}
            >
              <svg
                height={isMobile ? 40 : 32}
                width={isMobile ? 40 : 32}
                viewBox="0 0 64 64"
              >
                <circle cx={32} cy={32} r={32} fill="#aaa"></circle>
                <path
                  d="M50.9149 32.3209C55.0284 28.3565 55.0284 21.9363 50.9149 17.9719C47.2746 14.4636 41.5375 14.0075 37.3512 16.8913L37.2347 16.9685C36.1863 17.6912 35.9461 19.0946 36.696 20.098C37.4459 21.1013 38.902 21.3399 39.9431 20.6172L40.0596 20.54C42.3966 18.9332 45.5928 19.1858 47.6168 21.1434C49.9102 23.3537 49.9102 26.9322 47.6168 29.1424L39.448 37.0291C37.1546 39.2394 33.4415 39.2394 31.1482 37.0291C29.1169 35.0715 28.8548 31.9912 30.522 29.7458L30.6021 29.6336C31.352 28.6232 31.1045 27.2198 30.0634 26.5042C29.0223 25.7885 27.5589 26.02 26.8162 27.0234L26.7362 27.1356C23.7366 31.1632 24.2098 36.6923 27.8501 40.2006C31.9636 44.165 38.6253 44.165 42.7388 40.2006L50.9149 32.3209ZM13.0851 30.6791C8.97162 34.6435 8.97162 41.0637 13.0851 45.0281C16.7254 48.5364 22.4625 48.9925 26.6488 46.1087L26.7653 46.0315C27.8137 45.3088 28.0539 43.9054 27.304 42.902C26.5541 41.8987 25.098 41.6601 24.0569 42.3828L23.9404 42.46C21.6034 44.0668 18.4072 43.8142 16.3832 41.8566C14.0898 39.6393 14.0898 36.0608 16.3832 33.8506L24.552 25.9709C26.8454 23.7606 30.5585 23.7606 32.8518 25.9709C34.8831 27.9285 35.1452 31.0088 33.4779 33.2612L33.3979 33.3734C32.648 34.3838 32.8955 35.7872 33.9366 36.5029C34.9777 37.2186 36.4411 36.987 37.1838 35.9836L37.2638 35.8714C40.2634 31.8368 39.7902 26.3077 36.1499 22.7994C32.0364 18.835 25.3747 18.835 21.2612 22.7994L13.0851 30.6791Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default ShareBtn
